module.exports = __webpack_public_path__ + "img/7.924e059c.webp";